






































































































































































































































































































































































































































































import router from "@/router/router";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class protocol extends Vue {
  id: any = null;
  title = {
    1: "注册协议",
    2: "服务协议",
    3: "卫蓝e站用户信息保护及隐私政策",
  };

  agree() {
    if (this.id == 1) {
      router.replace({
        name: "Login",
      });
    } else if (this.id == 2) {
      router.replace({
        name: "Login",
      });
      // this.$router.back();
    } else if (this.id == 3) {
      router.replace({
        name: "Home",
      });
    }
  }

  created() {
    let { id } = this.$route.query;
    if (id) {
      this.id = id;
    }
  }
}
